import { useStore, useStoreMap } from 'effector-react/compat'
import { $allGroups } from '@entities/groups/model'

export const useGroups = () => useStore($allGroups)
export const useGeneralGroups = () => useStoreMap($allGroups, (groups) => groups.filter((x) => x.isGeneral))
export const useChildrenGroups = (groupId: number) =>
    useStoreMap({
        store: $allGroups,
        keys: [groupId],
        fn: (groups) => groups.filter((x) => x.parentClsGroupId === groupId)
    })
